<template>
  <UiSkeleton class-name="game-skeleton-item" :items="3" />
</template>

<script>
export default {
  name: 'GameSkeleton',
}
</script>

<style lang="scss" scoped>
::v-deep .game-skeleton-item {
  height: 700px;
  max-width: 1182px;
  margin: 0 auto;
  @include media(tablet) {
    margin-bottom: 16px;
  }
  &:first-child{
    height: 60px;
    border-radius: 0;
    max-width: 100%;
  }
  &:nth-child(2){
    display: none;
    @include media(desktop) {
      display: block;
      margin-bottom: 8px;
      visibility: hidden;
      height: 32px;
      &::before{
        content: '';
        display: block;
        margin-left: auto;
        border-radius: inherit;
        height: 100%;
        background: inherit;
        visibility: visible;
        width: 130px;
      }
    }
  }
}
</style>
